exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/_object-gops.js
// module id = 630
// module chunks = 0